import React from "react";
import { Form, Select, Space } from "antd";
const { Option } = Select;

const PaymentGender = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="gender"
      label="Gender"
      initialValue={"male"}
      rules={[
        {
          required: true,
          message: "Please select gender",
        },
      ]}
    >
      <Select placeholder={"Gender"} style={{ width: "100%" }} disabled={disabled}>
        <Option value="male">
          <Space align="center">
            <span>Male</span>
          </Space>
        </Option>
        <Option value="female">
          <Space align="center">
            <span>Female</span>
          </Space>
        </Option>
      </Select>
    </Form.Item>
  );
};

export default PaymentGender;
